import { ChevronDown, ChevronUp } from 'lucide-react'

export function getBdrInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

export function formatBdrDate(dateStr?: string): string {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' })
}

export function BdrSortIcon({
  field,
  sortField,
  sortDir,
  inactiveUsesUp = false,
}: {
  field: string
  sortField: string
  sortDir: string
  inactiveUsesUp?: boolean
}) {
  if (sortField !== field) {
    return inactiveUsesUp ? (
      <ChevronUp size={14} className="text-text-muted opacity-30" />
    ) : (
      <ChevronDown size={12} className="opacity-30" />
    )
  }
  return sortDir === 'asc' ? (
    <ChevronUp size={inactiveUsesUp ? 14 : 12} className="text-accent" />
  ) : (
    <ChevronDown size={inactiveUsesUp ? 14 : 12} className="text-accent" />
  )
}
